var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import * as CatizColors from './CMSTouchPanel/colors';
import WindowHeader from './WindowHeader';
import WindowTitle from './WindowTitle';
var RoleTable = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n"], ["\n  display: grid;\n"])));
export var flattenRoleArrForDisplay = function (items, levelDict, level) {
    if (level === void 0) { level = 1; }
    var resultArr = [];
    if (!items) {
        return [];
    }
    items.forEach(function (item, index) {
        var _a, _b;
        resultArr.push({
            label: item.label,
            console: item.console,
            status: item.status,
            roleStatus: item.roleStatus,
            level: level,
            isSelected: item.isSelected,
            levelDict: __assign(__assign({}, levelDict), (_a = {}, _a[level] = false, _a)),
            lastChild: items.length - 1 === index,
        });
        if (item.children) {
            resultArr = resultArr.concat(flattenRoleArrForDisplay(typeof item.children === 'string'
                ? JSON.parse(item.children)
                : item.children, __assign(__assign({}, levelDict), (_b = {}, _b[level] = items.length - 1 === index, _b)), level + 1));
        }
    });
    return resultArr;
};
var Row = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  grid-template-columns: 30px 245px 90px 50px;\n  display: grid;\n  height: 25px;\n  cursor: pointer;\n  :hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n  ", "\n  ", "\n"], ["\n  width: 100%;\n  grid-template-columns: 30px 245px 90px 50px;\n  display: grid;\n  height: 25px;\n  cursor: pointer;\n  :hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var isEven = _a.isEven;
    if (isEven) {
        return "background: " + CatizColors.deepBlue + ";";
    }
    else {
        return "background: " + CatizColors.blue + ";";
    }
}, function (_a) {
    var isSelected = _a.isSelected;
    if (isSelected) {
        return "background: rgba(255,255,255,0.6);";
    }
    return '';
});
var CenteredCell = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n  align-items: center;\n  height: 100%;\n"], ["\n  display: grid;\n  align-items: center;\n  height: 100%;\n"])));
var TableHeader = styled(Row)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: rgba(50, 59, 85);\n"], ["\n  background: rgba(50, 59, 85);\n"])));
var HeaderCell = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border: solid 1px gray;\n  text-align: center;\n  text-transform: uppercase;\n"], ["\n  border: solid 1px gray;\n  text-align: center;\n  text-transform: uppercase;\n"])));
var TableCell = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-transform: uppercase;\n  padding-left: 10px;\n  display: flex;\n  align-items: flex-start;\n"], ["\n  text-transform: uppercase;\n  padding-left: 10px;\n  display: flex;\n  align-items: flex-start;\n"])));
var CenteredTableCell = styled(TableCell)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var RightBorderCell = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  border-left: solid 1px white;\n  width: 2px;\n  height: 100%;\n"], ["\n  border-left: solid 1px white;\n  width: 2px;\n  height: 100%;\n"])));
var CurrentItem = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 10px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  left: -2px;\n"], ["\n  width: 10px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  left: -2px;\n"])));
var TreeContainer = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  height: 574px;\n  overflow-y: auto;\n  color: white;\n  border: solid 3px gray;\n"], ["\n  height: 574px;\n  overflow-y: auto;\n  color: white;\n  border: solid 3px gray;\n"])));
var InternalTopItem = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: 100%;\n  height: 50%;\n  border-bottom: solid 1px white;\n"], ["\n  width: 100%;\n  height: 50%;\n  border-bottom: solid 1px white;\n"])));
var InternalBottomItem = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  width: 100%;\n  height: 50%;\n  border-top: solid 1px white;\n"], ["\n  width: 100%;\n  height: 50%;\n  border-top: solid 1px white;\n"])));
var ButtonContainer = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 33% 33% 33%;\n  height: 30px;\n  > button {\n    background: ", ";\n    color: ", ";\n    border-radius: 8px;\n  }\n"], ["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 33% 33% 33%;\n  height: 30px;\n  > button {\n    background: ", ";\n    color: ", ";\n    border-radius: 8px;\n  }\n"])), CatizColors.blue, CatizColors.fontColor);
var RoleTypes;
(function (RoleTypes) {
    RoleTypes["Green"] = "green";
    RoleTypes["White"] = "white";
    RoleTypes["Orange"] = "orange";
})(RoleTypes || (RoleTypes = {}));
var RoleStatusSquare = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  width: 10px;\n  height: 10px;\n  ", "\n"], ["\n  width: 10px;\n  height: 10px;\n  ",
    "\n"])), function (_a) {
    var roleType = _a.roleType;
    if (roleType === RoleTypes.Green) {
        return "background: rgba(71,158,3,1);";
    }
    else if (roleType === RoleTypes.White) {
        return "background: white;";
    }
    else {
        return "background:rgba(253,144,14,1);";
    }
});
export default function RoleStatus(_a) {
    var content = _a.content;
    var roles = flattenRoleArrForDisplay(content, {});
    return (React.createElement(React.Fragment, null,
        React.createElement(WindowHeader, { name: 'CMS Role Status' }),
        React.createElement(WindowTitle, null, "Role Status"),
        React.createElement(RoleTable, null,
            React.createElement(TableHeader, null,
                React.createElement(HeaderCell, null),
                React.createElement(HeaderCell, null, "Role"),
                React.createElement(HeaderCell, null, "Console"),
                React.createElement(HeaderCell, null, "E/I/A")),
            React.createElement(TreeContainer, null, roles.map(function (role, index) {
                return (React.createElement(Row, { key: index, isEven: index % 2 === 0, isSelected: role.isSelected },
                    React.createElement(CenteredTableCell, null,
                        React.createElement(RoleStatusSquare, { roleType: role.roleStatus })),
                    React.createElement(TableCell, null,
                        React.createElement(LevelSpacer, { level: role.level, levelDict: role.levelDict, lastChild: role.lastChild }),
                        React.createElement(CenteredCell, null, role.label)),
                    React.createElement(TableCell, null, role.console),
                    React.createElement(TableCell, null, role.status)));
            })),
            React.createElement(ButtonContainer, null,
                React.createElement("button", null, "Assign"),
                React.createElement("button", null, "Unassign"),
                React.createElement("button", null, "Unassign All")))));
}
function LevelSpacer(_a) {
    var level = _a.level, levelDict = _a.levelDict, lastChild = _a.lastChild;
    return (React.createElement(React.Fragment, null,
        Array(level)
            .fill(1)
            .map(function (_, index) { return (React.createElement(RightBorderCell, { key: index, style: {
                marginRight: index === level - 1 ? '0px' : '18px',
                height: index === level - 1 && lastChild ? '55%' : '100%',
                borderLeftStyle: levelDict[index + 1] ? 'unset' : 'solid',
            } })); }),
        React.createElement(PresentItem, null)));
}
function PresentItem() {
    return (React.createElement(CurrentItem, null,
        React.createElement(InternalTopItem, null),
        React.createElement(InternalBottomItem, null)));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
//# sourceMappingURL=RoleStatus.js.map